import { Paper } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, { memo, useEffect, useMemo, useState } from "react";
import { Chip } from "../../../ui";
import { useQueryContext } from "../context";

const useStyles = makeStyles((theme) => ({
  root: {
    color: "#06F",
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    listStyle: "none",
    padding: "12px 6px",
    margin: "0",
    marginBottom: "20px",
  },
}));

const QueryChips = () => {
  const { params } = useQueryContext();
  const classes = useStyles();

  const paramsConfigs = useMemo(() => {
    return {
      basic: {
        tribunais: {
          defaultValue: [],
          displayValue: null,
          displayLabel: "Tribunal",
        },
        valorGteq: {
          defaultValue: "",
          displayValue: null,
          displayLabel: "Valor maior ou igual a",
        },
        valorLteq: {
          defaultValue: "",
          displayValue: null,
          displayLabel: "Valor menor ou igual a",
        },
        anosVencimento: {
          defaultValue: [],
          displayValue: null,
          displayLabel: "Ano de vencimento",
        },
        natureza: {
          defaultValue: "",
          displayValue: null,
          displayLabel: "Natureza",
        },
        tipoProcesso: {
          defaultValue: "",
          displayValue: null,
          displayLabel: "Tipo",
        },
      },
      advanced: {
        ufs: {
          defaultValue: [],
          displayValue: null,
          displayLabel: "UF",
        },
        unidades: {
          defaultValue: [],
          displayValue: null,
          displayLabel: "Comarca/Subseção",
        },
        assuntos: {
          defaultValue: [],
          displayValue: null,
          displayLabel: "Assunto",
        },
        devedores: {
          defaultValue: [],
          displayValue: null,
          displayLabel: "Devedor",
        },
        expedidoGteq: {
          defaultValue: null,
          displayValue: null,
          displayLabel: "Expedido a partir de",
        },
        expedidoLteq: {
          defaultValue: null,
          displayValue: null,
          displayLabel: "Expedido até",
        },
        municipal: {
          defaultValue: false,
          displayValue: null,
          displayLabel: "Tipo ente",
        },
        estadual: {
          defaultValue: false,
          displayValue: null,
          displayLabel: "Tipo ente",
        },
        federal: {
          defaultValue: false,
          displayValue: null,
          displayLabel: "Tipo ente",
        },
      },
      specific: {
        nrPrecatorio: {
          defaultValue: "",
          displayValue: null,
          displayLabel: "Número do precatório",
        },
        documento: {
          defaultValue: "",
          displayValue: null,
          displayLabel: "Documento de credor",
        },
        nomeCredor: {
          defaultValue: "",
          displayValue: null,
          displayLabel: "Nome de credor",
        },
        nrProcesso: {
          defaultValue: "",
          displayValue: null,
          displayLabel: "Número do processo de origem",
        },
        nomeAdvogado: {
          defaultValue: "",
          displayValue: null,
          displayLabel: "Nome de representante",
        },
        oabAdvogado: {
          defaultValue: "",
          displayValue: null,
          displayLabel: "OAB de representante",
        },
      },
    };
  });

  const [query, setQuery] = useState([]);

  useEffect(() => {
    if (Object.keys(params).length > 0) {
      let data = [];
      let general = true;

      const { specific } = params;

      for (var key of Object.keys(specific)) {
        const config = paramsConfigs.specific[key];
        const value = specific[key];

        if (value !== config.defaultValue) {
          config.displayValue = value;
          data.push(config);

          break;
        }
      }

      if (data.length == 0) {
        for (var queryType of ["basic", "advanced"]) {
          const typeParams = params[queryType];
          const typeConfig = paramsConfigs[queryType];

          for (var typeKey of Object.keys(typeParams)) {
            const value = typeParams[typeKey];
            let config = typeConfig[typeKey];

            if (JSON.stringify(config.defaultValue) === JSON.stringify(value))
              continue;

            switch (typeKey) {
              case "tribunais":
                general = false;
                continue;
              case "anosVencimento":
                let v = [];
                value.map((a) => v.push(a.id));
                config.displayValue = v.sort().join(", ");
                if (v.length > 1) config.displayLabel = "Anos de vencimento";
                data.push(config);

                continue;
              case "assuntos":
              case "devedores":
              case "ufs":
              case "unidades": {
                for (var index in value) {
                  const id = value[index]?.id;
                  const list = params.advanced[typeKey];
                  const object = list.filter((obj) => {
                    return obj.id == id;
                  })[0];

                  config.displayValue = object.nome;
                  data.push(config);
                }

                continue;
              }
              case "municipal":
              case "estadual":
              case "federal": {
                if (value) {
                  config.displayValue =
                    typeKey[0].toUpperCase() + typeKey.slice(1);
                  data.push(config);
                }

                continue;
              }
              case "valorGteq":
              case "valorLteq": {
                if (value != "") {
                  config.displayValue = new Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  }).format(value);
                  data.push(config);
                }

                continue;
              }
              case "expedidoGteq":
              case "expedidoLteq":
                if (value != "" && value != null && value != undefined) {
                  config.displayValue = new Date(value).toLocaleDateString(
                    "pt-BR"
                  );
                  data.push(config);
                }

                continue;
              default: {
                if (value != config.defaultValue) {
                  config.displayValue = value;
                  data.push(config);
                }

                continue;
              }
            }
          }
        }
      }

      if (general && data.length == 0)
        data.push({
          displayLabel: "Busca geral",
          displayValue: "",
        });

      setQuery(data);
    }
  }, [params]);

  return params && query.length > 0 ? (
    <Paper component="ul" className={classes.root} elevation={4}>
      {query.map((obj, index) => {
        return (
          <li key={index}>
            <Chip label={`${obj.displayLabel} ${obj.displayValue}`} />
          </li>
        );
      })}
    </Paper>
  ) : null;
};

export default memo(QueryChips);
